import React, { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress, Chip } from '@mui/material';
import { Timer, Warning } from '@mui/icons-material';

const QuizTimer = ({ durationMinutes, startTime, onTimeUp }) => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [isWarning, setIsWarning] = useState(false);

  useEffect(() => {
    const calculateRemaining = () => {
      const now = new Date();
      const start = new Date(startTime);
      const elapsedMs = now - start;
      const totalMs = durationMinutes * 60 * 1000;
      const remaining = Math.max(0, totalMs - elapsedMs);
      
      return Math.floor(remaining / 1000);
    };

    setRemainingSeconds(calculateRemaining());

    const interval = setInterval(() => {
      const remaining = calculateRemaining();
      setRemainingSeconds(remaining);

      // Activer l'avertissement si moins de 5 minutes
      if (remaining <= 300 && remaining > 0) {
        setIsWarning(true);
      }

      // Temps écoulé
      if (remaining <= 0) {
        clearInterval(interval);
        if (onTimeUp) {
          onTimeUp();
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [durationMinutes, startTime, onTimeUp]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const getProgress = () => {
    const totalSeconds = durationMinutes * 60;
    return ((totalSeconds - remainingSeconds) / totalSeconds) * 100;
  };

  const getColor = () => {
    if (remainingSeconds <= 60) return 'error';
    if (remainingSeconds <= 300) return 'warning';
    return 'primary';
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isWarning && <Warning color="warning" />}
          <Timer />
          <Typography variant="body2" color="text.secondary">
            Temps restant
          </Typography>
        </Box>
        <Chip 
          label={formatTime(remainingSeconds)}
          color={getColor()}
          sx={{ 
            fontFamily: 'monospace', 
            fontSize: '1.1rem',
            fontWeight: 'bold' 
          }}
        />
      </Box>
      <LinearProgress 
        variant="determinate" 
        value={getProgress()} 
        color={getColor()}
        sx={{ height: 8, borderRadius: 1 }}
      />
    </Box>
  );
};

export default QuizTimer;

